/*
 * @Author: lx 406054531@qq.com
 * @Date: 2024-05-20 11:17:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-01-10 15:47:12
 * @FilePath: \KPW-Digital-Grid-Management-Platform-System\src\router\module\information_management.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    path: '/information_management', //首页
    component: (resolve) => require(['@/views/information_management/information_management_home'], resolve),
    hidden: true,
    meta: {
      title: '首页',
      code: 'information_management',
    },
    children: [
      {
        path: 'info_management', //事件管理
        component: (resolve) => require(['@/views/information_management/info_management'], resolve),
        meta: {
          title: '事件管理',
          code: 'info_management',
        },
      },
      {
        path: 'add_edit_info',
        component: (resolve) => require(['@/views/information_management/add_edit_info'], resolve),
        meta: {
          code: 'add_edit_info',
        },
      },
      {
        path: 'video_management', //视频管理
        component: (resolve) => require(['@/views/information_management/video_management'], resolve),
        meta: {
          title: '视频管理',
          code: 'video_management',
        },
      },
      {
        path: 'place_management', //场所管理
        component: (resolve) => require(['@/views/information_management/place_management'], resolve),
        meta: {
          title: '场所管理',
          code: 'place_management',
        },
      },
      {
        path: 'edit_place_info', //编辑场所
        component: (resolve) => require(['@/views/information_management/add_edit_place'], resolve),
        meta: {
          title: '编辑场所',
          code: 'edit_place_info',
        },
      },
      {
        path: 'house_management', //房屋管理
        component: (resolve) => require(['@/views/information_management/house_management'], resolve),
        meta: {
          title: '房屋管理',
          code: 'house_management',
        },
      },
      {
        path: 'edit_house_info', //编辑房屋
        component: (resolve) => require(['@/views/information_management/edit_house_info'], resolve),
        meta: {
          title: '编辑房屋',
          code: 'edit_house_info',
        },
      },
      {
        path: 'basic_personnel_management', //基础人员管理
        component: (resolve) => require(['@/views/information_management/basic_personnel_management'], resolve),
        meta: {
          title: '基础人员管理',
          code: 'basic_personnel_management',
        },
      },
      {
        path: 'add_edit_basic_personnel', //编辑重点人员
        component: (resolve) => require(['@/views/information_management/add_edit_basic_personnel'], resolve),
        meta: {
          title: '编辑基础人员',
          code: 'add_edit_basic_personnel',
        },
      },
      {
        path: 'personnel_management', //人员管理
        name: 'personnel_management',
        component: (resolve) => require(['@/views/information_management/personnel_management'], resolve),
        meta: {
          title: '人员管理',
          code: 'personnel_management',
        },
      },
      {
        path: 'edit_personnel_info', //编辑重点人员
        component: (resolve) => require(['@/views/information_management/edit_personnel_info'], resolve),
        meta: {
          title: '编辑重点人员',
          code: 'edit_personnel_info',
        },
      },
      {
        path: 'event_type', //事件类型
        component: (resolve) => require(['@/views/information_management/config_setting/event_type'], resolve),
        meta: {
          title: '事件类型',
          code: 'event_type',
        },
      },
      {
        path: 'place_type', //场所类型
        component: (resolve) => require(['@/views/information_management/config_setting/place_type'], resolve),
        meta: {
          title: '场所类型',
          code: 'place_type',
        },
      },
      {
        path: 'house_type', //房屋类型
        component: (resolve) => require(['@/views/information_management/config_setting/house_type'], resolve),
        meta: {
          title: '房屋类型',
          code: 'house_type',
        },
      },
      {
        path: 'personnel_type', //人员类型
        component: (resolve) => require(['@/views/information_management/config_setting/personnel_type'], resolve),
        meta: {
          title: '人员类型',
          code: 'personnel_type',
        },
      },
      {
        path: 'else-strength-type', //其他力量类型
        component: (resolve) => require(['@/views/information_management/config_setting/else-strength-type'], resolve),
        meta: {
          title: '其他力量类型',
          code: 'else-strength-type',
        },
      },
      {
        path: 'special-crowd-type', //特殊人群类型
        component: (resolve) => require(['@/views/information_management/config_setting/special-crowd-type'], resolve),
        meta: {
          title: '特殊人群类型',
          code: 'special-crowd-type',
        },
      },
      {
        path: 'identification_management', //标识管理
        component: (resolve) => require(['@/views/information_management/identification_management'], resolve),
        meta: {
          title: '标识管理',
          code: 'identification_management',
        },
      },
      {
        path: 'else-strength', //其他力量
        component: (resolve) => require(['@/views/information_management/else-strength'], resolve),
        meta: {
          title: '其他力量',
          code: 'else-strength',
        },
      },
      {
        path: 'edit-strength-info', //编辑其他力量
        component: (resolve) => require(['@/views/information_management/edit-strength-info'], resolve),
        meta: {
          title: '编辑其他力量',
          code: 'edit-strength-info',
        },
      },
      {
        path: 'special-crowd', //特殊人群
        component: (resolve) => require(['@/views/information_management/special-crowd'], resolve),
        meta: {
          title: '基础人员管理',
          code: 'special-crowd',
        },
      },
      {
        path: 'add-edit-special-crowd', //特殊人群编辑
        component: (resolve) => require(['@/views/information_management/add-edit-special-crowd'], resolve),
        meta: {
          title: '编辑特殊人群',
          code: 'add-edit-special-crowd',
        },
      },
      {
        path: 'grid-user-dispose-statistics', //网格员处置事件统计
        component: (resolve) => require(['@/views/information_management/grid-user-dispose-statistics'], resolve),
        meta: {
          title: '网格员处置事件统计',
          code: 'grid-user-dispose-statistics',
        },
      },
      {
        path: 'masses-reporting-statistics', //网格员处置事件统计
        component: (resolve) => require(['@/views/information_management/masses-reporting-statistics'], resolve),
        meta: {
          title: '群众上报事件统计',
          code: 'masses-reporting-statistics',
        },
      },
      {
        path: 'visiting_record',
        component: (resolve) => require(['@/views/information_management/visiting_record'], resolve),
        meta: {
          title: '巡查走访管理',
          code: 'information_management_visiting_record',
        },
      },
      // {
      //   path: 'user_credit',
      //   component: (resolve) => require(['@/views/information_management/credit_manage/user_credit/index'], resolve),
      //   meta: {
      //     title: '用户积分',
      //     code: 'user_credit',
      //   },
      // },
      // {
      //   path: 'user_credit_record',
      //   component: (resolve) => require(['@/views/information_management/credit_manage/user_credit_record/index'], resolve),
      //   meta: {
      //     title: '用户积分记录',
      //     code: 'user_credit_record',
      //   },
      // },
      // {
      //   path: 'user_credit_type',
      //   component: (resolve) => require(['@/views/information_management/credit_manage/user_credit_type/index'], resolve),
      //   meta: {
      //     title: '用户积分类型',
      //     code: 'user_credit_type',
      //   },
      // },
      // {
      //   path: 'credit_goods_manage',
      //   component: (resolve) => require(['@/views/information_management/credit_manage/credit_goods_manage/index'], resolve),
      //   meta: {
      //     title: '积分商品管理',
      //     code: 'credit_goods_manage',
      //   },
      // },
      // {
      //   path: 'credit_rule',
      //   component: (resolve) => require(['@/views/information_management/credit_manage/credit_rule/index.vue'], resolve),
      //   meta: {
      //     title: '积分规则',
      //     code: 'credit_rule',
      //   },
      // },
      // {
      //   path: 'exchange_examine',
      //   component: (resolve) => require(['@/views/information_management/exchange_examine/index.vue'], resolve),
      //   meta: {
      //     title: '兑换审核',
      //     code: 'exchange_examine',
      //   },
      // },
      // {
      //   path: 'exchange_examine',
      //   component: (resolve) => require(['@/views/information_management/exchange_examine/index.vue'], resolve),
      //   meta: {
      //     title: '兑换审核',
      //     code: 'exchange_examine',
      //   },
      // },
      {
        path: 'notice_management',
        component: (resolve) => require(['@/views/system_setting/notice_management/notice_management.vue'], resolve),
        meta: {
          title: '通知管理',
          code: 'notice_management',
        },
      },

      {
        path: 'conflict_isputes_case_manage',
        component: (resolve) => require(['@/views/information_management/conflict_isputes_case_information/conflict_isputes_case_manage/index.vue'], resolve),
        meta: {
          title: '案例库管理',
          code: 'conflict_isputes_case_manage',
        },
      },
      {
        path: 'conflict_isputes_case_manage_add_update',
        component: (resolve) => require(['@/views/information_management/conflict_isputes_case_information/conflict_isputes_case_manage/addUpdate.vue'], resolve),
        meta: {
          title: '案例库管理新增编辑',
          code: 'conflict_isputes_case_manage_add_update',
        },
      },
      {
        path: 'conflict_isputes_case_type',
        component: (resolve) => require(['@/views/information_management/conflict_isputes_case_information/conflict_isputes_case_type/index.vue'], resolve),
        meta: {
          title: '案例类型',
          code: 'conflict_isputes_case_type',
        },
      },
      {
        path: 'registration_personnel',
        component: (resolve) => require(['@/views/information_management/flow_key_personnel_manage/registration_personnel_list/index.vue'], resolve),
        meta: {
          title: '流动人员登记',
          code: 'registration_personnel_list',
        },
      },
      {
        path: 'flow_key_personnel',
        component: (resolve) => require(['@/views/information_management/flow_key_personnel_manage/flow_key_personnel_list/index.vue'], resolve),
        meta: {
          title: '流动重点人员',
          code: 'flow_key_personnel_list',
        },
      },

    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/module/information_management.js